<!-- Login box -->
<div class="shared-login" [ngClass]="{ fullpage: showFullPage }">
  <div class="login" [ngClass]="{ shrink: formIsFocused }">
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="logo">
          <img src="{{ _logo }}" alt="avatar" class="img-responsive" />
        </div>
        <div class="row my-2">
          <div
            class="col"
            [ngClass]="
              formHelper?.isFieldValidCss('username', formSubmitAttempted)
            "
          >
            <!-- email field -->
            <ion-input
              type="text"
              (focus)="shrink(true)"
              class="form-control"
              id="inputUsername"
              label="{{ 'login_email' | translate }}"
              formControlName="username"
            ></ion-input>
            <!-- error message -->
            <shared-field-error-display
              [shouldDisplayError]="
                !!formHelper?.isFieldValid('username', formSubmitAttempted)
              "
            ></shared-field-error-display>
          </div>
        </div>
        <div class="row mt-1">
          <div
            class="col"
            [ngClass]="
              formHelper?.isFieldValidCss('password', formSubmitAttempted)
            "
          >
            <!-- password field -->
            <ion-input
              type="password"
              (focus)="shrink(true)"
              class="form-control"
              id="inputPassword"
              label="{{ 'login_password' | translate }}"
              formControlName="password"
            ></ion-input>
            <!-- error message -->
            <shared-field-error-display
              [shouldDisplayError]="
                !!formHelper?.isFieldValid('password', formSubmitAttempted)
              "
            ></shared-field-error-display>
          </div>
        </div>
        @if (loginFailed) {
          <div class="row mt-1 mt-3 text-center field-error">
            <div class="col">
              {{ 'login_failed' | translate }}
            </div>
          </div>
        }
        <div class="row">
          <div class="col">
            <!-- forgot password -->
            @if (showForgotPassword) {
              <a id="btn-forgot-password" (click)="onForgotPasswordCl()">{{
                'login_forgotPassword' | translate
              }}</a>
            }
            <!-- login button -->
            <button type="submit" id="btn-login" class="btn" mdbWavesEffect>
              {{ 'login_login' | translate }}
            </button>
            <!-- register link -->
            @if (showRegister) {
              <a id="btn-register" (click)="onRegisterCl()">{{
                'login_register' | translate
              }}</a>
            }
          </div>
        </div>
      </form>
    }
  </div>
</div>
